import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-layers",
  "use": "svg-layers-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke-linejoin=\"bevel\" stroke-width=\".5\" id=\"svg-layers\"><path d=\"m0 16 12-7.5L24 16l-12 7.5Z\" fill=\"#ddddddef\" /><path d=\"m0 16 12 7.5L24 16\" stroke=\"#737373\" /><path d=\"m0 12.25 12-7.5 12 7.5-12 7.5Z\" fill=\"#ddddddef\" /><path d=\"m0 12.25 12 7.5 12-7.5\" stroke=\"#737373\" /><path d=\"M0 8.5 12 1l12 7.5L12 16Z\" fill=\"#ddddddef\" /><path d=\"M0 8.5 12 16l12-7.5\" stroke=\"#737373\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol